class Jump {
  constructor(config = {}) {
    const {
      graphicSelector,
    } = config;

    this.graphicsSelector = document.querySelectorAll(graphicSelector);
    this.graphicsSelectorArray = Array.prototype.slice.call(this.graphicsSelector);

    if (this.graphicsSelector) {
      this.bindEvents();
    }
  }

  bindEvents() {
    window.addEventListener('scroll resize', () => {
      this.graphicsSelectorArray.forEach(graphicItem => {
        // console.log(graphicItem);
        this.toggleClassOnGraphic(graphicItem, e);
      });
    });
  }

  toggleClassOnGraphic(item, e) {
    if (Helper.isInViewport(item)) {
      Helper.toggleClass(item, '.jump-animate');
      item.addEventListener('scroll', e => {
        Helper.addClass(item, 'scrolled');
      });

      setTimeout(() => {
        if (!item.classList.contains('.jump-animate') && !item.classList.contains('.scrolled')) {
          Helper.addClass(item, '.jump-animate');
        }
      }, 4000);
    }
  }
}

export default Jump;
